import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { RootState } from '../redux/store';
import { isLoggedIn } from '../utils/utils';
import { NAVIGATE_ADMIN, NAVIGATE_DASHBOARDS } from '../constant';

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
    const authUser = useSelector((state: RootState) => state.authUser);
    const { menus } = useSelector((state: RootState) => state.permission);
    const isRolesPermissionsSet = localStorage.getItem('roles_permissions') !== null;
    const UserAdminType: string[] = ['tho', 'admin', 'cmrf', 'mo', 'dho'];

    if (isLoggedIn(authUser) && menus?.length > 0 && isRolesPermissionsSet) {
        if (authUser.User.user_type === 'hospital') {
            return <Navigate to={NAVIGATE_ADMIN.CAMPAIGN_LIST_PAGE} />;
        } else if (UserAdminType.includes(authUser.User.user_type)) {
            return <Navigate to={NAVIGATE_ADMIN.CAMPAIGN_LIST_PAGE} />;
        } else if (authUser.User.user_type === 'survey_user') {
            return <Navigate to={NAVIGATE_DASHBOARDS.SURVEY_POLICY_DASHBOARD_PAGE} />;
        } else if (authUser.User.user_type === 'bhajani_mandal') {
            return <Navigate to={NAVIGATE_ADMIN.BHAJANI_MANDAL_LIST_PAGE} />;
        }
        else {
            return <Navigate to={NAVIGATE_ADMIN.CAMPAIGN_LIST_PAGE} />;
        }
    }

    return <>{children}</>;
};

export default AuthLayout;